'use strict';

var basketCounter = {
    selector: '[data-basket-count]',

    init: function() {
        var $counts = $(this.selector);
        if ($counts.length) {
            var basketCount = getCookie('basket-count');

            if (basketCount == null) {
                $(this.selector).remove();
                return false;
            }

            var basketText = basketCount;
            if ($('[data-basket-count-trimmed]').length == 0) {
                basketText = basketCount;
            }
            $counts.text(basketText);
            setCookie('basket-count', basketCount, 3650);
        }

        var circleCountBasket = document.getElementsByClassName('count-circle');
        if (basketCount < 1) {
            $(this.selector).remove();
        }
        for (var i = 0; i < circleCountBasket.length; i++) {
            if (basketCount >= 1) {
                circleCountBasket[i].classList.add('count-basket');
            } else {
                circleCountBasket[i].classList.remove('count-basket');
            }
        }

        function getCookie(name) {
            var result = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return result ? result[2] : null;
        }

        function setCookie(name, value, days) {
            var expireDate = new Date;
            expireDate.setTime(expireDate.getTime() + 24 * 60 * 60 * 1000 * days);
            document.cookie = name + '=' + value + ';path=/;expires=' + expireDate.toUTCString();
        }
    }
};
